import React, { Component } from 'react'
import Header from '../widgets/common/Header'
import Footer from '../widgets/common/Footer'
import GenericModal from '../widgets/common/GenericModal'
import NoResources from '../widgets/resources/noResources'
import Loading from '../widgets/Loading'
import { Col, Row } from 'react-flexbox-grid'
import Card from '@material-ui/core/Card'
import { withStyles } from '@material-ui/core/styles'
import NgrxAuth from '../auth/Auth'
import RBButton from '../controls/RBButton'
import { downloadResource } from '../redux/actions/resourcesActions'
import { fetchPension } from '../redux/actions/memberSummaryActions'
import CardStyles from '../styles/cards'
import ButtonStyles from '../styles/buttons'
import IconStyles from '../styles/icons'
import { localize } from '../util/Localizer'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import classnames from 'classnames'
import mime from 'mime'
import JSZip from 'jszip'
import Icon from '@material-ui/core/Icon'
import { openBlob, b64toBlob } from '../util/BlobHelpers'
import PensionStatements from '../widgets/Member/pensionWidgets/PensionStatements'

class Resources extends Component {
  constructor (props) {
    super(props)

    this.downloadResource = this.downloadResource.bind(this)
    this.onDownloadFile = this.onDownloadFile.bind(this)
    this.onDownloadFileError = this.onDownloadFileError.bind(this)
    this.capitalize = this.capitalize.bind(this)

    this.state = {
      showGenericModal: false,
      loading: false
    }
  }

  componentDidMount () {
    if (!this.props.pension) {
      this.props.fetchPension()
    }
  }

  downloadResource (resourceType) {
    this.setState({ loading: true })
    this.props.downloadResource(resourceType, this.onDownloadFile, this.onDownloadFileError)
  }

  capitalize (string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  onDownloadFile () {
    this.setState({ loading: false })

    const { resource } = this.props
    const hasResource = (typeof resource === 'object' && resource !== null)

    if (hasResource && Array.isArray(resource) && !resource.hasErrorField) {
      if (resource.length > 1) {
        const zip = new JSZip()

        resource.forEach(file => {
          zip.folder('Documents').file(file.fileNameField, file.fileContentField, { base64: true })
        })

        zip.generateAsync({ type: 'blob' }).then(blob => {
          openBlob(blob, 'Documents.zip')
        })
      } else {
        resource.forEach(file => {
          // Get a mime type for the given file extension so we
          // can attempt to decode the file correctly:
          const mimeType = mime.getType(file.fileTypeField.toUpperCase())
          // It's very unlikely that we'll come across an unsupported
          // file type, but ignore the file if we do:
          if (mimeType) {
            const blob = b64toBlob(file.fileContentField, mimeType)
            openBlob(blob, file.fileNameField)
          } else {
            this.setState({ showGenericModal: true })
          }
        })
      }
    } else {
      this.setState({ showGenericModal: true })
    }
  }

  onDownloadFileError () {
    this.setState({ loading: false })
  }

  returnPension () {
    const { memberSummary = {} } = this.props

    if (memberSummary && memberSummary.isPensionAvailable) {
      return (
        <div>
          <PensionStatements pension={this.props.pension} classes={{}} />
        </div>
      )
    } else return null
  }

  renderLoading () {
    return (
      <div><Loading message={localize('common.loadingContent')} /></div>
    )
  }

  render () {
    const { classes = {} } = this.props
    const memberResources = (this.props.memberSummary && this.props.memberSummary.memberResources) || {}

    let newResources = Object.keys(memberResources).map(function (key) {
      return { [key]: memberResources[key] }
    })

    var ret = (
      <div className='pageContent'>
        <Header />
        <section className='mainContent'>
          <Col lg={10} lgOffset={1}>
            <h4 className='sectionHeading'>{localize('pages.Resources.header')}</h4>
            <div className='resourceContainer'>
              {(this.state.loading || (this.props.isAnyMemberResource && !memberResources) || this.props.memSumLoading)
                ? <Loading message={localize('common.loadingContent')} />
                : (this.props.isAnyMemberResource
                  ? <Card className={classnames(classes.summaryCard, classes.baseCard)}>
                    <Col lg={8} md={10} xs={12} >
                      {this.props.isLoading === true && this.renderLoading()}
                      <div className={'resourcesButtonBox'}>
                        {newResources && newResources.map((r, k) => {
                          const val = Object.values(r)[0]
                          const title = Object.keys(r)[0]
                          const download = this.capitalize(title)

                          if ((val === true) && (title !== 'priorAuthorization') && (title !== 'specialEvaluation')) {
                            return (
                              <Row className='paddingBottom20px' key={k}>
                                <RBButton // className='resourcesButton'
                                  className={classes.resourcesButton}
                                  label={localize(`pages.Resources.${title}`)}
                                  variant='outlined'
                                  fullWidth
                                  labelPosition='before'
                                  styles={{ justifyContent: 'start' }}
                                  onClick={() => { this.downloadResource(`${download}`) }}
                                  icon={<Icon className={classes.borderedIcon}>arrow_downward</Icon>}
                                />
                              </Row>
                            )
                          } else {
                            return null
                          }
                        })}

                      </div>
                    </Col>
                  </Card>

                  : (<NoResources />))}
              <br/>
              {this.returnPension()}
            </div>

          </Col>
          {this.state.showGenericModal
            ? <GenericModal
              open={this.state.showGenericModal}
              handleClose={() => {
                this.setState({ showGenericModal: false })
              }}
              modal
              message='Something went wrong while downloading resource. Please try again'
            /> : null}
          <Footer />
        </section>
      </div>
    )

    return ret
  }
}

function mapStateToProps (state, ownProps) {
  return {
    memberSummary: (state.memberSummaryReducer && state.memberSummaryReducer.memberSummary),
    memSumLoading: state.memberSummaryReducer.isLoading,
    error: state.ResourcesReducer.error || '',
    resource: state.ResourcesReducer.resource || '',
    isLoading: state.ResourcesReducer.isLoadings,
    isAnyMemberResource: NgrxAuth.isAnyMemberResource,
    pension: state.memberSummaryReducer.pension || {},
    pensionIsLoading: state.memberSummaryReducer.pensionIsLoading
  }
}

const ConnectedResources = connect(mapStateToProps, { downloadResource, fetchPension })(injectIntl(Resources))

const styles = {
  ...CardStyles,
  ...ButtonStyles,
  ...IconStyles
}

export default withStyles(styles)(ConnectedResources)



// WEBPACK FOOTER //
// ./src/components/Resources.js